module.exports = __webpack_public_path__ + "img/wind-1.76ee7771.jpg";